// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3NN3c","header":"ReportDetails_header__2h-Lf","title":"ReportDetails_title__3W7J5","left":"ReportDetails_left__dj_mh"};